"use strict";

export const module1 = (() => {
  const init = () => {
    console.log("module 1 inited");
  };

  return {
    init
  };
})();
